import React, { useState, useEffect } from 'react'

export default function YourReportsAccountSection({
  accountList = [],
  accountId,
  onAccountChange,
}) {
  const [dropdownValue, setDropdownValue] = useState(accountId)

  useEffect(() => {
    setDropdownValue(accountId)
  }, [accountId])

  return (
    <>
      <h4 className="u-paddingBottom2gu u-textSizeMsr">Your Accounts</h4>
      <div className="u-sizeFull u-lg-size5of12 u-flex u-paddingBottom8gu">
        <div className="Dropdown u-flexGrow1">
          <select
            className="Dropdown-menu u-paddingVert2gu"
            name="your-accounts-dropdown"
            data-qa-automation={'your-accounts-dropdown'}
            onChange={(e) => setDropdownValue(e.currentTarget.value)}
            defaultValue={dropdownValue}
          >
            {accountList?.map((itx) => (
              <option key={itx.acctId} value={itx.acctId}>
                {itx.acctNm}
              </option>
            ))}
          </select>
        </div>
        <div className="u-flex">
          <button
            disabled={accountId === dropdownValue}
            onClick={() => onAccountChange({ accountId: dropdownValue })}
            className="Button Button--primary  Button--small u-paddingHoriz5gu"
          >
            GO
          </button>
        </div>
      </div>
    </>
  )
}
